import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { useState } from 'react';
import {
  DELIVERY_TYPE,
  DownloadOptionsModel,
  FORMAT,
  ORIENTATION,
} from 'src/models/DownloadModel';
import { DIALOGS } from 'src/models/DialogModel';
import { ENTITIES } from 'src/models/QuerybuilderModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import {
  postDownloadEntitesAction,
  postDownloadSelectedEntitesAction,
  postEmailEntitesAction,
  postEmailSelectedEntitesAction,
} from 'src/redux/actions/querybuilderActions';

type RecurringScope = 'all' | 'result' | 'selected';

const DownloadRecurringDialog = () => {
  const dispatch = useAppDispatch();
  const lang = useSelector((state: Store) => state.language.language ?? 'en');
  const opened = useSelector(
    (state: Store) => state.dialog[DIALOGS.recurringDownload]?.opened || false,
  );
  const count = useSelector(
    (state: Store) => (
      state.querybuilder[ENTITIES.recurrings]
        && (state.querybuilder[ENTITIES.recurrings].result?.count || 0)
    ),
  );
  const selections = useSelector(
    (state: Store) => state.selected[ENTITIES.recurrings] || [],
  );

  const [scope, setScope] = useState<RecurringScope>(
    selections.length ? 'selected' : 'all',
  );
  const [delivery, setDelivery] = useState<DELIVERY_TYPE>(DELIVERY_TYPE.download);

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.recurringDownload }));
  };

  const handleDownload = () => {
    const options: DownloadOptionsModel = {
      file: 'subscriptions.csv',
      orientation: ORIENTATION.landscape,
      format: FORMAT.csv,
      delivery,
      export_to_grid: false,
      all: scope === 'all',
    };

    if (delivery === DELIVERY_TYPE.download) {
      if (scope === 'selected') {
        dispatch(postDownloadSelectedEntitesAction(ENTITIES.recurrings, selections, options));
      } else {
        dispatch(postDownloadEntitesAction(ENTITIES.recurrings, options));
      }
    } else if (scope === 'selected') {
      dispatch(postEmailSelectedEntitesAction(ENTITIES.recurrings, selections, options));
    } else {
      dispatch(postEmailEntitesAction(ENTITIES.recurrings, options));
    }

    dispatch(closeDialog({ dialog: DIALOGS.recurringDownload }));
  };

  return (
    <Dialog maxWidth="sm" fullWidth aria-labelledby="download-recurring" open={opened}>
      <DialogTitle id="download-recurring">
        {t(lang, 'forms.subscriptions.download_title')}
      </DialogTitle>
      <DialogContent dividers>
        <FormControl component="fieldset" style={{ marginTop: '8px' }}>
          <FormLabel component="legend">{t(lang, 'forms.subscriptions.export_to')}</FormLabel>
          <RadioGroup
            row
            aria-label="scope"
            name="scope"
            value={scope}
            onChange={(e) => setScope(e.target.value as RecurringScope)}>
            <FormControlLabel
              value="all"
              control={<Radio />}
              label={t(lang, 'forms.subscriptions.all')} />
            <FormControlLabel
              value="result"
              control={<Radio />}
              label={`${t(lang, 'forms.subscriptions.result')} (${count})`} />
            <FormControlLabel
              value="selected"
              control={<Radio />}
              label={`${t(lang, 'forms.subscriptions.selected')} (${selections.length})`}
              disabled={!selections.length} />
          </RadioGroup>
        </FormControl>
        <FormControl component="fieldset" style={{ marginTop: '8px' }}>
          <FormLabel component="legend">{t(lang, 'forms.subscriptions.delivery')}</FormLabel>
          <RadioGroup
            row
            aria-label="delivery"
            name="delivery"
            value={delivery}
            onChange={(e) => setDelivery(e.target.value as DELIVERY_TYPE)}>
            <FormControlLabel
              value={DELIVERY_TYPE.download}
              control={<Radio />}
              label={t(lang, 'misc.download')} />
            <FormControlLabel
              value={DELIVERY_TYPE.email}
              control={<Radio />}
              label={t(lang, 'forms.subscriptions.by_email')} />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
          {t(lang, 'misc.cancel')}
        </Button>
        <Button onClick={handleDownload} color="primary">
          {t(lang, 'misc.download')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DownloadRecurringDialog;
